import { defineMessages } from "react-intl"

export const CREATE_PO_BUTTON_MESSAGES = defineMessages({
    buttonLabel: {
        id: "order.components.create_po_button.buttonLabel",
        defaultMessage: "Create Purchase Order",
    }
})

export const CREATE_PO_MODAL_MESSAGES = defineMessages({
    header: {
        id: "order.modals.create_po_modal.header",
        defaultMessage: "New Purchase Order",
    },
    supplierSelectPlaceholder: {
        id: "order.modals.create_po_modal.supplier_select_placeholder",
        defaultMessage: "Select a supplier...",
    },
    supplierSelectLabel: {
        id: "order.modals.create_po_modal.supplier_select_label",
        defaultMessage: "Supplier:",
    },
    createButtonLabel: {
        id: "order.modals.create_po_modal.create_button_label",
        defaultMessage: "Create Purchase Order",
    },
})


// WEBPACK FOOTER //
// ./src/utils/order/messages.ts